// React
import React from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'
import { compose } from 'redux'

// Libraries

// Components

// Shared
import ReactCSSTransitionGroup from 'shared/lib/react_css_transition_group'
import Format from 'shared/utils/format'
import { setUserFrameworkCartData } from 'shared/utils/userFrameworkEvents'
import clientActions from 'store/v2/redux/actions/client'
import { withTranslation } from 'shared/utils/withTranslation'

export class Launcher extends React.Component {
  static displayName = 'Launcher'

  static propTypes = {
    itemCount: PropTypes.number,
    cartOpen: PropTypes.bool,
    toggleCart: PropTypes.func,
    cart: PropTypes.object,
    useTimes: PropTypes.bool,
    usePrices: PropTypes.bool,
    timeFormat: PropTypes.string,
    floating: PropTypes.bool,
    totalPriceAttribute: PropTypes.string,
    currency: PropTypes.object,
    t: PropTypes.func
  }

  componentDidUpdate = () => {
    setUserFrameworkCartData()
  }

  get style () {
    const { floating } = this.props

    if (floating) {
      return {
        position: 'fixed',
        bottom: 15,
        right: 15
      }
    } else {
      return {}
    }
  }

  get countLabel () {
    const { itemCount, t } = this.props

    if (itemCount === 1) {
      return `${itemCount} ${t('user.store.item')}`
    }

    return `${itemCount} ${t('user.store.items')}`
  }

  render () {
    const launcherClassNames = []
    const { cart, cartOpen, toggleCart, useTimes, usePrices, timeFormat, itemCount, currency, totalPriceAttribute, t } = this.props

    launcherClassNames.push(cartOpen ? 'open' : 'closed')

    return (
      <ReactCSSTransitionGroup
        transitionName="booqable-launcher"
        transitionEnterTimeout={300}
        transitionLeaveTimeout={100}
      >
        <div
          key={`booqable-launcher-${cartOpen}`}
          id="booqable-launcher"
          className={launcherClassNames.join(' ')}
          style={this.style}
          onClick={toggleCart.bind(null, !cartOpen)}
        >
          <div className="bq-branded" id="booqable-launcher-icon">
            <i className="bq-branded bq-icon-cart fas fa-shopping-cart" aria-hidden="true" />
          </div>
          <div id="booqable-launcher-summary">
            <div className="bq-dates">
              {cart && cart.starts_at ?
                (
                  <span>
                    <strong>{Format.date(cart.starts_at, 'shortDate')} </strong>
                    <small>{useTimes && Format.date(cart.starts_at, timeFormat)}</small>
                    {' - '}
                    <strong>{Format.date(cart.stops_at, 'shortDate')} </strong>
                    <small>{useTimes && Format.date(cart.stops_at, timeFormat)}</small>
                  </span>
                ) :
                (<span>{t('user.store.select_a_period')}</span>)}
            </div>
            <hr />
            <div className="bq-summary">
              {cart && itemCount ?
                (
                  <div>
                    <span>
                      <strong>{this.countLabel}</strong>
                    </span>
                    {usePrices && (
                      <span className="bq-total">
                        <strong>
                          {Format.money(cart != null ? cart.get(totalPriceAttribute) : undefined, currency)}
                        </strong>
                      </span>
                    )}
                  </div>
                ) :
                (<span>{t('user.store.cart_empty')}</span>)}
            </div>
          </div>
        </div>
      </ReactCSSTransitionGroup>
    )
  }
}

const mapStateToProps = (state) => {
  let timeFormat, totalPriceAttribute

  if (state.settings.get('dates.use_am_pm')) {
    timeFormat = 'hh:mm A'
  } else {
    timeFormat = 'HH:mm'
  }

  const cart = state.orm.carts.getById(state.client.cartId)
  const lines = state.orm.lines.getAll({
    id: cart != null ? cart.lines : undefined,
    product_type: ['consumable', 'sales_item', 'rental', 'bundle']
  })

  const itemCount = lines.map((line) => line.quantity).reduce((a, b) => a + b, 0)

  if (state.settings.get('pricing.tax_strategy') === 'inclusive') {
    totalPriceAttribute = 'grand_total_with_tax_in_cents'
  } else {
    totalPriceAttribute = 'grand_total_in_cents'
  }

  return {
    floating: state.client.floatingCart,
    cartOpen: state.client.cartOpen,
    cart,
    currency: state.client.currency.toJS(),
    totalPriceAttribute,
    timeFormat,
    useTimes: state.settings.get('store.use_times'),
    usePrices: state.settings.get('store.use_prices'),
    itemCount
  }
}

const mapDispatchToProps = () => {
  return {
    toggleCart: (cartOpen) => {
      return clientActions.toggleCart(cartOpen)
    }
  }
}

export default compose(withTranslation('user'), reduxConnect(mapStateToProps, mapDispatchToProps))(Launcher)
